<template>
    <v-main >
        <v-app-bar color="teal accent-4" dark @click="mini = !mini">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            </v-app-bar>
        <v-main color="black">
            <v-container>
                <router-view></router-view>
            </v-container>
        </v-main>
        <v-navigation-drawer v-model="drawer" @click="mini = !mini" :mini-variant.sync="mini" dense :permanent="drawer" app>
            <v-list
                dense
                color="teal accent-4"
            >
                    <v-list-item >
                    <v-list-item-action>
                        <v-icon color="white" @click.stop="drawer = !drawer">mdi-chevron-left</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            <h3 class="font-weight-thick white--text">Gitlab Hook Dashboard</h3>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list-item class="px-2" @click="mini = !mini">
                <v-list-item-avatar>
                    <v-img v-if="avatar.isImage" :src="avatar.url"></v-img>
                    <v-icon v-else>mdi-account-circle</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="text-truncate">
                    {{ name }}
                </v-list-item-content>
                <v-btn icon small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
            </v-list-item>
            <v-divider></v-divider>
            <v-list dense >
                    <v-list-item v-for="item in drawerItems" :key="item.title" link :to="item.href">
                        <v-list-item-icon>
                            <v-icon color="teal accent-4">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="teal--text">{{ item.title }}</v-list-item-title>
                    </v-list-item>
            </v-list>
            <template v-slot:append>
                <v-list class="pa-2" dense>
                <v-list-item @click="logout">
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
                </v-list>
            </template>
        </v-navigation-drawer>
    </v-main>
</template>

<script>
export default {
    data() {
        return {
            drawer: true,
            name: this.$store.state.authentication.user.name,
            mini: true,
            drawerItems: [
                { title: "Home", icon: "mdi-home", href: "/" },
                { title: "Audit", icon: "mdi-text-box-search", href: "/audit" },
                { title: "Account", icon: "mdi-account", href: "/account" },
            ],
        }
    },
    methods: {
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        logout() {
            this.$store.dispatch('authentication/logout')
        },
    },
    computed: {
        avatar() {
            return this.$store.getters['authentication/userAvatar']
        }
    },

}
</script>
